import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <main className="page page--narrow" id="main">
      <div className="card card--center">
        <h1 className="card__title">Page not found</h1>
        <p className="muted">That page doesn’t exist. If you were sent a room link, check it was copied in full.</p>
        <Link to="/" className="btn btn--primary">
          Go to SuperFunUBG
        </Link>
      </div>
    </main>
  );
}
